// Types
import { NewFeatureCarouselModalType } from 'Dashboard/components/NewFeatureCarouselModal/NewFeatureCarouselModal.types';
import { Illustrations } from 'Wpds/components/illustration';

// Constants
import Colors from 'Wpds/colors/ColorConstants';

export const Data = {
  slides: [
    {
      slug: 'peer-review-completed-slide',
      title: 'Nice work on that review',
      imageBgColor: Colors.purple[25],
      image: Illustrations.person_with_confetti_falling_with_purple_bg,
      imageWidth: '165px',
      nextBtnLabel: 'Done',
      description: `Take a moment to acknowledge your growth. Your work here is done.`,
    },
  ],
} as NewFeatureCarouselModalType;
